import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MasterContainerComponent } from './layout/master-container/master-container.component';
import { EmptyContainerComponent } from './layout/empty-container/empty-container.component';

const routes: Routes = [
  { path: 'home', redirectTo: '', pathMatch: 'full' },
  {
    path: '',
    component: EmptyContainerComponent,
    children: [
      {
        path: '',
        loadChildren: './index/index.module#IndexModule'
      }
    ]
  },
  {
    path: 'auth',
    component: EmptyContainerComponent,
    children: [
      {
        path: '',
        loadChildren:
          './authentication/authentication.module#AuthenticationModule'
      }
    ]
  },
  {
    path: 'pages',
    component: MasterContainerComponent,
    children: [
      {
        path: '',
        redirectTo: 'fraud',
        pathMatch: 'full'
      },
      {
        path: 'page/:slug/:id',
        loadChildren: './core/core.module#CoreModule'
      },
      {
        path: 'fraud',
        loadChildren: './fraud/fraud.module#FraudModule'
      },
      {
        path: 'mediacenter',
        loadChildren: './media-center/media-center.module#MediaCenterModule'
      },
      {
        path: 'ShareYourExperience',
        loadChildren:
          './share-your-experience/share-your-experience.module#ShareYourExperienceModule'
      },
      {
        path: 'AboutTheProgram',
        loadChildren:
          './about-the-program/about-the-program.module#AboutTheProgramModule'
      },
      {
        path: 'profilePage',
        loadChildren:
          './profile/profile.module#ProfileModule'
      },
      {
        path: 'search',
        loadChildren:
          './search/search.module#SearchModule'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
